export default __webpack_public_path__ + "static/media/shield.b6112ff8.png";